const clubsConfig = {
  '80f53ef6-6373-11ea-bc55-0242ac130003': {
    denyAddClub: true
  }
}

export function getClubsConfig(clubId) {
  return clubsConfig[clubId]
}



// WEBPACK FOOTER //
// ./src/components/Clubs/clubsConfig.js